function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
  fill: "#338af3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#acabb1",
  d: "M304.083 286.736l-31.112-31.112 29.615-29.616-1.342-15.642-8.478-8.48L256 238.652l-36.766-36.766-8.478 8.48-1.342 15.642 29.615 29.616-31.112 31.112 16.97 16.97L256 272.594l31.113 31.112z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M301.255 210.367l-16.971 16.971c7.238 7.239 11.716 17.239 11.716 28.285 0 22.092-17.909 40.001-40.001 40.001s-40.001-17.909-40.001-40.001c0-11.045 4.478-21.045 11.716-28.285l-16.971-16.971C199.162 221.949 192 237.949 192 255.623c0 35.346 28.654 64 64 64s64-28.654 64-64c0-17.674-7.164-33.674-18.745-45.256z",
  fill: "#6da544"
});

const SvgGuatemala = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGuatemala, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/guatemala.2c5d207d.svg";
export { ForwardRef as ReactComponent };